<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {
  <app-api-table
    [endpoint]="'/visits/tables/supervisors-performance'"
    [name]="'Supervisors Performance'"
  ></app-api-table>
  }
</app-tab-layout>
